import { useAtomValue } from 'jotai';

import { isOnlineAtom } from '@/services/globalState';

/** Whether the device has a connection, for features that wait to fetch until it does. */
export function useIsOnline() {
  return useAtomValue(isOnlineAtom);
}
